export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.ed09e3b7.png";